interface GetBackendEnvironmentParams {
  backendUrl: Maybe<string>
}

export const PRODUCTION_BACKEND_ENVIRONMENT = 'production'

/**
 * The environment a Settle backend host belongs to: `api.settle.co` is production, every other one is
 * named by what precedes `-api` (`stg-api.settle.co` → `stg`). A host outside that convention (localhost,
 * a PR preview, tests) is labelled by its first hostname label, so only the real production host ever
 * reads as such. Empty when the url is unset.
 */
export const getBackendEnvironment = ({ backendUrl }: GetBackendEnvironmentParams): string => {
  if (!backendUrl) {
    return ''
  }

  const { hostname } = new URL(backendUrl)
  const [label = ''] = hostname.split('.')

  if (!hostname.endsWith('.settle.co')) {
    return label
  }

  return label === 'api' ? PRODUCTION_BACKEND_ENVIRONMENT : label.replace(/-api$/, '')
}
